import React from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";
import { CSVLink } from "react-csv";

import ButtonDownloadHollow from "../../reuseableComponents/buttons/ButtonDownloadHollow";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import { GET_USER_REPORT } from "../../../queries/ddwAdminQrys/SysAdminReportQrys";
import UserReportTable from "./UserReportTable";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const UserReportPage = () => {
  const { loading, error, data } = useQuery(GET_USER_REPORT);
  if (!data || loading || error)
    return (
      <div className='page-container user-report-container'>
        <Row>
          <Col>
            <h3>User Report</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            {!data || loading ? <SkeletonLoader width='100%' /> : ""}
            {error ? <ErrorHandler error={error} /> : ""}
          </Col>
        </Row>
      </div>
    );
  return (
    <div className='page-container user-report-container'>
      <Row>
        <Col>
          <h3 className='align-middle'>User Report</h3>
        </Col>
        <Col>
          <CSVLink
            style={{ float: "right" }}
            data={data.getAllUsersCsvReport}
            filename='waterlinkAllUsersReport.csv'
            target='_blank'
          >
            <ButtonDownloadHollow label='Download CSV' id='ddw-primary-hollow' />
          </CSVLink>
        </Col>
      </Row>
      <Row>
        <Col>
          <UserReportTable data={data.getAllUsersCsvReport} />
        </Col>
      </Row>
    </div>
  );
};

export default UserReportPage;
